import { ReactElement, useEffect, useState } from 'react'
import { I18n, Translate, Translate2 } from 'common'
import { useNavigate } from 'react-router-dom'
import { breakpoints } from '../../../../theme/breakpoints'
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add'
import ListServiceProvider from '../../../../services/ListServiceProvider'
import {
  AddPartToList,
  ListResponseError,
} from '../../../../store/lists/interfaces'
import { StoreInstances } from '../../../../store/StoreInstancesContainer'
import { AxiosError } from 'axios'
import { Select, Button } from '../../../../ui-components'
import styles from '../AddToListDrawer/AddToListDrawer.module.scss'
import { ProductModel } from 'interfaces'
import { IdValueGeneric } from 'interfaces'

type IselectedCatListGroup = IdValueGeneric<number, string>

interface AddPartsToListProps {
  categories
  selectedProduct: ProductModel
  totalQty: number
  handleClose
  handleAddNewList
}

export const AddPartsToList = (props: AddPartsToListProps): ReactElement => {
  const {
    categories,
    selectedProduct,
    totalQty,
    handleClose,
    handleAddNewList,
  } = props

  const navigate = useNavigate()
  const [selectedCategoryOption, setSelectedCategoryOption] =
    useState<IselectedCatListGroup>({
      id: null,
      value: null,
    })
  const [lists, setLists] = useState([])
  const [selectedListOption, setSelectedListOption] =
    useState<IselectedCatListGroup>({
      id: null,
      value: null,
    })
  const [groups, setGroups] = useState([])
  const [selectedGroupOption, setSelectedtGroupOption] =
    useState<IselectedCatListGroup>({
      id: null,
      value: null,
    })
  const [disableAddToList, setDisableAddToList] = useState(true)

  useEffect(() => {
    if (selectedCategoryOption && selectedListOption && selectedGroupOption) {
      setDisableAddToList(false)
    } else {
      setDisableAddToList(true)
    }
  }, [selectedCategoryOption, selectedListOption, selectedGroupOption])

  const getGroupsData = async () => {
    const { groups } = await ListServiceProvider.getListDetails(
      selectedCategoryOption.id,
      selectedListOption.id
    )
    const temp = groups.map((grp) => {
      return {
        ...grp,
        value: grp.name,
      }
    })
    setGroups(temp)
  }

  useEffect(() => {
    if (selectedListOption && selectedListOption.id !== null) getGroupsData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedListOption])

  const handleSelectedCategory = (selectedCategory) => {
    setSelectedCategoryOption(selectedCategory)
    setSelectedListOption(null)
    setLists(selectedCategory.lists)
    setSelectedtGroupOption(null)
  }

  const handleSelectedList = (selected) => {
    setSelectedListOption(selected)
    setSelectedtGroupOption(null)
  }

  const handleSelectedGroup = (selected) => {
    setSelectedtGroupOption(selected)
  }

  const handleAddNewList1 = (): void => {
    setSelectedCategoryOption(null)
    setSelectedtGroupOption(null)
    handleAddNewList()
  }

  const cutText = (text: string): string => {
    const maxLength = 4
    let cutText = text.substr(0, maxLength)

    // Check if the cut text ends with a period
    if (cutText.endsWith('.')) {
      return cutText
    }

    cutText = cutText.trim()

    // Check if there are spaces within the cut text
    const lastSpaceIndex = cutText.lastIndexOf(' ')
    if (lastSpaceIndex !== -1) {
      cutText = cutText.substr(0, lastSpaceIndex)
    }

    return cutText + '...'
  }

  const addPartToList = async (req: Array<AddPartToList>) => {
    try {
      const status = await ListServiceProvider.addPartToGroup(
        selectedListOption.id,
        selectedGroupOption.id,
        req
      )
      if (status === 200 || status === 206) {
        let description = `${req[0]?.partDescription} (${req[0]?.partNumber})`
        const isTablet = window.innerWidth < breakpoints.tablet
        if (isTablet) {
          description = cutText(description)
        }
        StoreInstances.uiStore.displaySuccessNotification(
          Translate2('itemAddedToListMessage', [
            description,
            selectedListOption?.value,
          ]),
          {
            text: 'viewLists',
            action: req[0]?.handleListLocation,
          }
        )
        req[0]?.handleClose()
      }
    } catch (error) {
      const { message }: ListResponseError = (error as AxiosError).response
        .data as ListResponseError
      StoreInstances.uiStore.displayErrorNotification(message)
    }
  }

  const handleData = () => {
    const req = [
      {
        lineCode: selectedProduct.lineCode,
        partNumber: selectedProduct.partNumber,
        stockQty: totalQty,
        comment: '',
        partDescription: selectedProduct.description,
        handleListLocation,
        handleClose,
      },
    ]
    addPartToList(req)
  }

  const handleListLocation = () => {
    return navigate('lists')
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerWrapper}>
        <p className={styles.styledText}>
          <I18n name="addPartToList" />
        </p>
        <CloseIcon className={styles.styledCloseIcon} onClick={handleClose} />
      </div>
      <div className={styles.selectsWrapper}>
        <p className={styles.selectsLabels}>
          {' '}
          <I18n name="category" />
        </p>
        <Select
          optionFontSize="16px"
          options={categories ? categories : []}
          selectedOption={selectedCategoryOption}
          onSelect={handleSelectedCategory}
        />
        <p className={styles.selectsLabels}>
          {' '}
          <I18n name="list" />
        </p>
        <Select
          optionFontSize="16px"
          options={lists}
          selectedOption={selectedListOption}
          onSelect={handleSelectedList}
        />

        <p className={styles.selectsLabels}>
          {' '}
          <I18n name="group" />
        </p>
        <Select
          optionFontSize="16px"
          options={groups ? groups : []}
          selectedOption={selectedGroupOption}
          onSelect={handleSelectedGroup}
        />
      </div>

      <div
        className={styles.addNewListWrapper}
        role="presentation"
        onClick={handleAddNewList1}
      >
        <AddIcon />
        <I18n name="addNewList" />
      </div>
      <div className={styles.buttonsWrapper}>
        <Button
          onClick={handleClose}
          variant="secondary"
          size="medium"
          text={Translate('cancel')}
        />

        <Button
          onClick={handleData}
          variant="primary"
          size="medium"
          text={Translate('addToList')}
          disabled={disableAddToList}
        />
      </div>
    </div>
  )
}
